import { render, staticRenderFns } from "./StepThree.vue?vue&type=template&id=6bc38b8a&scoped=true&"
import script from "./StepThree.vue?vue&type=script&lang=js&"
export * from "./StepThree.vue?vue&type=script&lang=js&"
import style0 from "./StepThree.vue?vue&type=style&index=0&id=6bc38b8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc38b8a",
  null
  
)

export default component.exports